const INITIAL_STATE = {
  mode: "create",
  clientId: null,
  isPrivate: false,
  isFavorite: false,

  clientDetails: {
    clientName: "",
    sourceOfClientName: "",
    clientNumber: "",
    usptoCustomerNumber: "21971",
    address: "",
    phone: "",
    entityStatus: "",
    entityStatusSource: "",
    corporationCountry: "",
    corporationState: "",
    executedPoa: "",
    executedPoaLocation: "",
    assignmentCountry: "",
    assignmentState: "",
    signatory: "",
    signatoryTitle: "",
    pps: "",
    ffs: "",
    usPatentParalegal: "",
    lastUpdatedOn: "",
    correspondanceTo: [],
    documentUrls: [],
  },

  assignments: [],

  licensedFamilies: [],

  statusByFamily: [],

  paralegalInstructions: [],

  ppsInstructions: [],

  recurringActions: [],

  foreignAssociates: [],

  inventors: [],

  billing: {
    instructions: [],
    invoicing: [],
    idsBillingArrangements: [],
  },

  clientPreferences: [],

  attorneyPreferences: [],

  annuties: [],

  additionalInfo: [],

  // Backend-driven RBAC permissions keyed by model/section id (e.g. 'Inventor')
  sectionPermissionsById: {},
};

const kotClientReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_CLIENT_MODE":
      return {
        ...state,
        mode: action.payload.mode,
        clientId: action.payload.clientId,
      };

    case "UPDATE_SECTION":
      return {
        ...state,
        [action.payload.section]: action.payload.value,
      };

    case "RESET_CLIENT_FORM":
      return INITIAL_STATE;

    case "SET_FULL_CLIENT":
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default kotClientReducer;
